export const chartTypes = ["official", "operational"] as const;
